import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CoordinatorEQuery} from '../../models/e-query-details/coordinator-e-query';

@Component({
    selector: 'coordinator-e-query-title',
    template: require('./coordinator-e-query-title.component.html'),
    styles: [require('./coordinator-e-query-title.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoordinatorEQueryTitleComponent {
    @Input()
    public eQuery: CoordinatorEQuery;
}